<div class="col-12 pb-0">
  <div class="row p-fluid p-formgrid grid">
    <div class="col-1">
      <!-- <a routerLink="/tramdo" style="color: rgb(180 180 195);">
        <i class="fa fa-home" style="font-size: 20px;"></i>
      </a> -->
      <p-dropdown [options]="listTramDo" [(ngModel)]="itemTramDo" optionLabel="title" (onChange)="onChangeTramDo()">
      </p-dropdown>
    </div>
    <div class="col-6 col-md-6">
      <div class="section-title" style="margin-bottom: 0px;">
        <h3 style="margin-bottom: 0px;">{{itemTramDo.title}}</h3>
        <p style="margin-top: 5px;">{{itemTramDo.address}}</p>
      </div>
    </div>
    <div class="col-5 col-md-6 field" style="margin-bottom: 0px;">
      <div class="navbar-area" ngStickyNav stickyClass="sticky-box-shadow" ngStickyNav>
        <nav class="navbar navbar-expand-lg navbar-light bg-light " [class.active]="classApplied">
          <button class="navbar-toggler" type="button" (click)="toggleClass()">
            <span class="burger-menu">
              <span class="top-bar"></span>
              <span class="middle-bar"></span>
              <span class="bottom-bar"></span>
            </span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav">
              <li class="nav-item"><a routerLink="/" class="nav-link">Trang chủ</a>
              <li class="nav-item" *ngIf="currentUser.typeId == 1"><a routerLink="/tramdo" class="nav-link">Trạm
                  đo</a>
              <li class="nav-item"><a routerLink="/bieudo" class="nav-link">Biểu đồ</a>
              <li class="nav-item"><a routerLink="/baocao" class="nav-link">Báo cáo</a>
              </li>
              <li class="nav-item">
                <a [routerLink]="['/bando']" routerLinkActive="router-link-active" class="nav-link">
                  Bản đồ</a>
              </li>
              <li class="nav-item" *ngIf="currentUser.typeId == 1">
                <a [routerLink]="['/admin']" routerLinkActive="router-link-active" class="nav-link">
                  Quản trị</a>
              </li>
              <li class="nav-item ">
                <a href="#" class="nav-link">Tài khoản</a>
                <ul class="dropdown-menu">
                  <li class="nav-item"><a [routerLink]="['/profile']" routerLinkActive="router-link-active"
                      class="nav-link">
                      Thông tin cá nhân</a>
                  </li>
                  <li class="nav-item"><a href="#" routerLinkActive="router-link-active" class="nav-link"
                      (click)="logOut()">
                      Thoát</a>
                  </li>
                </ul>
              </li>

            </ul>
            <ul class="navbar-nav for-responsive">
              <li class="nav-item"><a routerLink="/" class="nav-link">Trang chủ</a>
              <li class="nav-item" *ngIf="currentUser.typeId == 1"><a routerLink="/tramdo" class="nav-link">Trạm đo</a>
              <li class="nav-item"><a routerLink="/bieudo" class="nav-link">Biểu đồ</a>
              <li class="nav-item"><a routerLink="/baocao" class="nav-link">Báo cáo</a>
              <li class="nav-item"><a [routerLink]="['/map']" routerLinkActive="router-link-active" class="nav-link">
                  Bản đồ</a>
              </li>
              <li class="nav-item" *ngIf="currentUser.typeId == 1">
                <a [routerLink]="['/admin']" routerLinkActive="router-link-active" class="nav-link">
                  Quản trị</a>
              </li>
              <li class="nav-item ">
                <a href="#" class="nav-link">Tài khoản</a>
                <ul class="dropdown-menu">
                  <li class="nav-item"><a [routerLink]="['/profile']" routerLinkActive="router-link-active"
                      class="nav-link">
                      Thông tin cá nhân</a>
                  </li>
                  <li class="nav-item"><a href="#" routerLinkActive="router-link-active" class="nav-link"
                      (click)="logOut()">
                      Thoát</a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  </div>
</div>
<div class="col-12 pl-2 pr-3 pt-0 home">
  <div class="row grid">
    <div class="md:col-6 sm:col-12">
      <ng-container *ngFor="let item of dataSource; index as i">
        <div class="col-12">
          <div class="row">
            <div class="col-lg-5 col-sm-5 col-md-5">
              <p-card [style]="{ background: 'rgb(24, 27, 31)',  height: '180px'}">
                <ng-template pTemplate="header">
                  <h5 style="color: rgb(180 180 195); text-align: center; font-weight: 200">
                    <a href="/bieudo/{{itemTramDo.id}}" style="color: rgb(180 180 195);">
                      <i class="{{item.icon}}"></i> {{item.titleDmYeuToDo}} ({{item.codeDmYeuToDo}})
                    </a>
                  </h5>
                </ng-template>
                <ng-template pTemplate="body">
                  <div style="text-align: center;">
                    <h1 style="color: {{item.color}}">{{item.giaTri}} ({{item.donViDo}})</h1>
                    <p>Thời gian đo: {{item.thoiGianDo}}</p>
                    <strong style="color: rgb(180 180 195);">{{getTrangThaiHoatDong(item.trangThaiHoatDong,
                      item.trangThaiHoatDongData)}}</strong>
                  </div>
                </ng-template>
              </p-card>
            </div>
            <div class="col-lg-7 col-sm-7 col-md-7">
              <p-card [style]="{ background: 'rgb(24, 27, 31)',  height: '180px'}">
                <ng-template pTemplate="header">
                  <h5 style="text-align: center; font-weight: 200">
                    <a href="/baocao/{{itemTramDo.id}}" style="color: rgb(180 180 195);">Biểu đồ
                      {{item.titleDmYeuToDo}}</a>
                  </h5>
                </ng-template>
                <p class="m-0">
                  <p-chart type="bar" [data]="chartDatas[i]" [options]="chartOptions" [plugins]="plugin" />
                </p>
              </p-card>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="md:col-6 sm:col-12">
      <div class="col-12 pt-0">
        <div class="row">
          <div class="col-lg-5 col-sm-5 col-md-5">
            <ng-container *ngFor="let item of dataSource1; index as i">
              <ng-container *ngIf="item.codeDmYeuToDo == 'dd'">
                <div class="col-12" style="padding-right: 10px;">
                  <div class=" row">
                    <highcharts-chart [Highcharts]="Highcharts" [options]="polarChartOptions"
                      style="width: 100%; height: 330px;  padding-left: 0px;padding-right: 0px; display: block;">
                    </highcharts-chart>
                  </div>
                  <div class="row mt-1" style="background-color: rgb(24, 27, 31); min-height: 60px;">
                    <h5
                      style="color: rgb(204, 204, 220); text-align: center; margin-top: 10px; margin-bottom: 10px; font-weight: 300;">
                      {{ (getTextHuongGio(itemHuongGio.giaTri)).toUpperCase()}} <br />
                      ({{itemHuongGio.giaTri}}
                      {{itemHuongGio.donViDo}})
                    </h5>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </div>
          <div class="col-lg-7 col-sm-7 col-md-7 p-0 pl-1">
            <div class="col-12">
              <div #mapRef style="width:100%;height:390px"></div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="row">
    <ng-container *ngFor="let item of dataSource1; index as i">
      <div class="col-6 col-md-6">
        <div class="row">
          <div class="col-lg-5 col-sm-5 col-md-5">
            <p-card [style]="{ background: 'rgb(24, 27, 31)',  height: '180px'}">
              <ng-template pTemplate="header">
                <h5 style="color: rgb(180 180 195); text-align: center; font-weight: 200">
                  <a href="/bieudo/{{itemTramDo.id}}" style="color: rgb(180 180 195);">
                    <i class="{{item.icon}}"></i> {{item.titleDmYeuToDo}} ({{item.codeDmYeuToDo}})
                  </a>
                </h5>
              </ng-template>
              <ng-template pTemplate="body">
                <div style="text-align: center;">
                  <h1 style="color: {{item.color}}">{{item.giaTri}} ({{item.donViDo}})</h1>
                  <p>Thời gian đo: {{item.thoiGianDo}}</p>
                  <strong style="color: rgb(180 180 195);">{{getTrangThaiHoatDong(item.trangThaiHoatDong,
                    item.trangThaiHoatDongData)}}</strong>
                </div>
              </ng-template>
            </p-card>
          </div>
          <div class="col-lg-7 col-sm-7 col-md-7 ">
            <p-card [style]="{ background: 'rgb(24, 27, 31)',  height: '180px'}">
              <ng-template pTemplate="header">
                <a href="/baocao/{{itemTramDo.id}}" style="color: rgrgb(180 180 195);">
                  <h5 style="color: rgb(180 180 195); text-align: center; font-weight: 200">
                    Biểu đồ {{item.titleDmYeuToDo}}
                  </h5>
                </a>
              </ng-template>
              <p class="m-0">
                <p-chart type="bar" [data]="chartDatas1[i]" [options]="chartOptions" [plugins]="plugin" />
              </p>
            </p-card>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>